export enum Validator {
  REQUIRED = 'required',
  REQUIRED_NOT_BLANK = 'requiredNotBlank',
  REQUIRED_TRUE = 'requiredTrue',
  EMAIL = 'email',
  PHONE_NUMBER_ZEROES = 'phoneNumberZeroes',
  PHONE_NUMBER_REQUIRED = 'phoneNumberRequired',
  NIP = 'nip',
  PESEL = 'pesel',
  LEGAL_AGE_PESEL = 'legalAgePesel',
  REGON = 'regon',
  LAND_MORTGAGE_REGISTER = 'landMortgageRegister',
  POSTAL_CODE = 'postalCode',
  IBAN = 'iban',
  PATTERN = 'pattern',
  PATTERN_EMAIL = 'patternEmail',
  MAX_LENGTH = 'maxLength',
  MIN_LENGTH = 'minLength',
  MIN_LENGTH_NOT_BLANK = 'minLengthNotBlank',
  OR = 'OR',
  AND = 'AND'
}
